import {
  error,
  LaunchPinwheelFlowActionFragment,
} from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const BorrowingPowerPage = gql`
  ${AnalyticsEventFragment}
  ${error}
  ${LaunchPinwheelFlowActionFragment}
  query borrowingPowerPage($input: BorrowingPowerPageInput!) {
    borrowingPowerPage(input: $input) {
      __typename
      ... on BorrowingPowerPageSuccess {
        id
        borrowingPowerPageTitle: title
        subTitle
        content {
          __typename
          id
          title
          subTitle
          contentList {
            __typename
            itemType
            content
          }
        }
        disclaimer
        footerButton {
          __typename
          id
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on RouteNavigationAction {
              __typename
              route
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
            ...LaunchPinwheelFlowActionFragment
          }
        }
        displayAnalytics {
          ...AnalyticsEventFragment
        }
      }

      ... on BorrowingPowerPageError {
        __typename
        ...error
      }
    }
  }
`;

export default BorrowingPowerPage;
